<template>
    <div>
        <div v-if="!loading" class="home-pag">
          <banner title="Details Notice"
              subTitle="Welcome to the University of Chittagong (CU).">
          </banner>
          <section class="agency blog-sec blog-sidebar single_blog_item">
            <div class="container">
              <div class="row">
                <div class="col-12"> 
                  <div class="blog-text m-t-20">
                    <h6>July, 24th 2019</h6><a href="#">
                    <h3 class="blog-head">Sandford Stadium Improvements</h3></a>
                    <div class="blog-divider"></div>
                    <div class="blog-description">
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been
                        the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                        galley of
                        type and scrambled it to make a type specimen book. It has survived not only five centuries,
                        but
                        also the leap into electronic typesetting, remaining essentially unchanged. It was
                        popularised in
                        the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                        recently
                        with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                      </p>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been the
                        industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                        of type and
                        scrambled it to make a type specimen book. It has survived not only five centuries, but also
                        the leap
                        into electronic typesetting, remaining essentially unchanged. It was popularised in the
                        1960s with the
                        release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software
                        like Aldus PageMaker including versions of Lorem Ipsum.
                      </p>
                                <!-- <h5>Mark jkcno</h5>
                                <h5 class="pull-right">10 <i class="fa fa-heart-o"></i>, 50 <i class="fa fa-comments-o"></i>
                                </h5> -->
                    </div>
                  </div>
                        <!-- Comment Sec Start -->

                        
                        
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        <div class="tap-top">
            <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
        </div>
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
// import VuePdfApp from "vue-pdf-app";
// import toastr from "vue-toastr";
// import this to use default icons for buttons
// import "vue-pdf-app/dist/icons/main.css";
// import Advantage from './Advantage'
// import Contact from './Contact'
// import PageFooter from '../Partial/Footer'
import Banner from '../Partial/Banner'
// import LatestNews from '../Partial/LatestNews'
// import Login from '../Auth/Login'
// import { HOME_PAGE_INFO, REGISTRATION, SEND_CONFIRMATION_CODE, VERIFY_CONFIRMATION_CODE, CLAIM_STUDENT_REQUEST } from '../../const/api'
// import { GET, POST } from '../../utils/Request'

export default {
  name: 'NoticeDetails',
  components: { Loader, Banner },
  data() {
    return {
        loading: true,
        firstTimeLoad: true,
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.timeoutForLoading();
  },
  mounted() {   
  },
  methods: {
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-height"));
    },
    goForUrl(url) {
      this.$router.replace(url)
    },
    
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false
            }.bind(this),
            1000
          )
        })
      }
      this.firstTimeLoad = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:100vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}

</style>
